export default "__VITE_ASSET__DA0u0zmq__"